<template>
  <v-dialog v-model="dialog" width="600px">
    <v-card>
      <v-btn absolute icon right style="margin-top: 10px" @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-card-title>{{ $t("contractDocuments") }}</v-card-title>
      <v-card-text>
        <div class="ma-n2">
          <div v-if="documents.length === 0" class="pa-2">
            {{ $t("noDataAvailable") }}
          </div>
          <div v-else>
            <div
              v-for="(item, index) in documents"
              :key="`document-${index}`"
              class="pa-2"
            >
              <v-sheet
                v-if="$can($permissions.CONTRACT_AGGREMENT_FILE_DELETED)"
                class="rounded d-flex pa-2 align-center text-ellipsis position_relative"
                color="primary"
                dark
              >
                <v-btn
                  :loading="item.loading"
                  class="mr-1"
                  icon
                  small
                  @click="removeFileHandler(index)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <span class="text-no-wrap overflow-hidden">{{
                  item.name
                }}</span>
                <downloader
                  :address="item.link"
                  btn-class="white--text"
                  :file-name="item.name"
                  absolute
                  icon
                  right
                  small
                />
              </v-sheet>
            </div>
          </div>
          <div class="pa-2">
            <v-sheet
              class="pa-2 cursor-pointer d-flex justify-center rounded"
              color="primary"
              dark
              @click="addFileHandler"
            >
              <vue-icon v-show="!loading" icon="plusIcon"></vue-icon>
              <v-progress-circular
                v-show="loading"
                indeterminate
                size="15"
                width="3"
              ></v-progress-circular>
            </v-sheet>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <input
      ref="fileInput"
      class="d-none"
      type="file"
      @change="uploadFileHandler"
    />
  </v-dialog>
</template>

<script>
import Downloader from "@/components/ui/downloader";

const defaultCurrentItem = { id: null, index: null };
export default {
  name: "OzlContractDocumentDialog",
  components: { Downloader },
  data() {
    return {
      dialog: false,
      loading: false,
      currentItem: { ...defaultCurrentItem },
      documents: [],
    };
  },
  methods: {
    close() {
      this.documents = [];
      this.currentItem = { ...defaultCurrentItem };
      this.dialog = false;
    },
    open({ documents, id, index }) {
      if (documents) {
        this.documents = documents.map((item) => {
          return {
            name: item.name,
            link: item.link,
            loading: false,
          };
        });
      }
      this.currentItem = { id, index };
      this.dialog = true;
    },
    addFileHandler() {
      if (!this.loading) {
        const { fileInput } = this.$refs;
        fileInput.click();
      }
    },
    async removeFileHandler(index) {
      try {
        this.documents[index].loading = true;
        await this.$http.delete("contract/agreement-file-delete", {
          data: {
            contractId: this.currentItem.id,
            name: this.documents[index].link,
          },
        });
        this.documents.splice(index, 1);
        this.$emit("updated-files", {
          documents: this.documents,
          index: this.currentItem.index,
        });
        this.setSuccess({ text: this.$t("successfullyDeleted") });
      } catch (e) {
        this.documents[index].loading = false;
        this.setResponseError({ error: e });
      }
    },
    async uploadFileHandler(e) {
      const file = e.target.files;
      if (file[0]) {
        this.loading = true;
        const formData = new FormData();
        formData.append("file", file[0]);
        formData.append("id", this.currentItem.id);
        try {
          const {
            data: {
              data: { name, originalName },
            },
          } = await this.$http.post("contract/agreement-file", formData);
          this.documents.push({
            name: originalName,
            loading: false,
            link: name,
          });
          this.$emit("updated-files", {
            documents: this.documents,
            index: this.currentItem.index,
          });
          this.setSuccess({ text: this.$t("successfullySaved") });
        } catch (e) {
          this.setResponseError({ error: e });
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>
